// store/auth.js
import axios from 'axios'
const state = {
    user: null,    // 用户信息对象
    token: null,   // 认证token
    isAuthenticated: false // 认证状态
}

const mutations = {
    SET_AUTH(state, { user, token }) {
        state.user = user
        state.token = token
        state.isAuthenticated = !!token
    },
    CLEAR_AUTH(state) {
        state.user = null
        state.token = null
        state.isAuthenticated = false
    }
}

const actions = {
    login({ commit }, { user, token }) {
        // 1. 存入Vuex
        commit('SET_AUTH', { user, token })

        // 2. 存入本地存储
        localStorage.setItem('auth_token', token)
        localStorage.setItem('user_info', JSON.stringify(user))

        // 3. 设置axios默认授权头
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
    },

    logout({ commit }) {
        // 1. 清除Vuex
        commit('CLEAR_AUTH')

        // 2. 清除本地存储
        localStorage.removeItem('auth_token')
        localStorage.removeItem('user_info')

        // 3. 移除axios授权头
        delete axios.defaults.headers.common['Authorization']
    },

    initializeAuth({ commit }) {
        // 应用启动时从本地存储恢复登录状态
        const token = localStorage.getItem('auth_token')
        const user = JSON.parse(localStorage.getItem('user_info'))

        if (token && user) {
            commit('SET_AUTH', { user, token })
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
        }
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}